import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const FeaturesPage = lazy(() => import('../pages/features/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/[slug]/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const PartnershipsPage = lazy(() => import('../pages/partnerships/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/features',
    element: <FeaturesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/partnerships',
    element: <PartnershipsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
